import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';

export function Protected({ children, requireAdmin = false }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && role !== 'admin') {
    return (
      <div className="p-8">
        <h1 className="text-xl font-semibold">Admins only</h1>
        <p className="text-slate-600 mt-2">This area requires admin permissions.</p>
      </div>
    );
  }
  return children;
}
